export const environment = {
    production: false,
    "MAGIC_LINK_APIKEY": "pk_live_79D29E6BB12AA169", // "pk_live_E18822D98353C635", 
    "WALLET_CONNECT_PROJECT": "678b6c90e035db50d79ef26ecfb4c0e5",
    "ENVIRONEMNT_URL": "https://prediction-market-api.blockchainx.tech", // "https://polymarket-api.blockchainx.tech",
    "TRADING_ENGINE_URL": "https://prediction-market-trade-engine.blockchainx.tech/",
    "SOCKET_ENVIRONMENT_URL": "ws://164.90.149.221:9000/ws",
    "CONTRACT_ADDRESS": "0xaacFeEa03eb1561C4e67d661e40682Bd20E3541b",
    "CTF_EXCHANGE_ADDRESS": "0xB8b616447EDE2D93B9103267C81269F7D4611556",
    "MAGIC_REDIRECT_URI": "http://localhost:4200/callback",
    "WS_BASE_URL": 'wss://prediction-market-api.blockchainx.tech/ws/connect',
    "PROJECT_ID": "678b6c90e035db50d79ef26ecfb4c0e5",
    "SUPPORTED_NETWORK": [{ id: 1, name: "Ethereum" }, { id: 137, name: "Polygon" }, { id: 11155111, name: "Sepolia" }, { id: 80002, name: "Polygon Amoy" }], // using dummy network objects for now, will replace with chain imports in service if needed
    "PROJECT_URL": "http://localhost:4200",
    "UMA_ADAPTER_ADDRESS": "0x1Ce36689BB9BC3c9720222AA24618Ab3d4924eCa",
    "USDC_ADDRESS": "0x41E94Eb019C0762f9Bfcf9Fb1E58725BfB0e7582",
    "FRONTEND_URL": "https://prediction-market.blockchainx.tech/",
    "PROVIDERS": {
        polygonAmoy: 'https://rpc-amoy.polygon.technology',

    }
};
